import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FuseSharedModule} from '../../../../@fuse/shared.module';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {KluhSharedModule} from '../../kluh-shared.module';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSelectModule} from '@angular/material/select';
import {MatGridListModule} from '@angular/material/grid-list';
import {NgBytesPipeModule} from '../../pipes/bytes-pipe';
import {GuacDaoService} from './guac-dao.service';
import {GuacServerDaoService} from './guac-server/guac-server-dao.service';
import {GuacServerComponent} from './guac-server/guac-server.component';
import {MatMenuModule} from '@angular/material/menu';
import {AuthService} from '../../auth.service';
import {RouterModule} from '@angular/router';
import {GuacServerListComponent} from './guac-server/guac-server-list/guac-server-list.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {GuacServerEditComponent} from './guac-server/guac-server-edit/guac-server-edit.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {GuacServerInUseComponent} from './guac-server/guac-server-in-use/guac-server-in-use.component';

const routes = [
    {
        path: 'guac-server',
        component: GuacServerComponent,
        canActivate: [AuthService],
        data: {
            permissions: ['GuacServer.CREATE'],
            preCondition: true
        }
    }
];


@NgModule({
    imports: [
        CommonModule,
        FuseSharedModule,
        MatCardModule,
        RouterModule.forChild(routes),
        MatIconModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MatInputModule,
        MatButtonModule,
        KluhSharedModule,
        MatToolbarModule,
        MatTableModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        MatDialogModule,
        MatSelectModule,
        MatGridListModule,
        NgBytesPipeModule,
        MatMenuModule,
        FontAwesomeModule,
        MatProgressSpinnerModule,
        MatTooltipModule
    ],
    providers: [GuacDaoService, GuacServerDaoService],
    entryComponents: [],
    declarations: [GuacServerComponent, GuacServerListComponent, GuacServerEditComponent, GuacServerInUseComponent],

})
export class GuacModule {
}
